export default "__VITE_PUBLIC_ASSET__b1803648__"